import React, { useEffect } from "react";
import TIM from "@tencentcloud/chat";
import TIMUploadPlugin from "tim-upload-plugin";
import AvChatRoom from "./AVChatRoom";

interface ChatProps {
  tim: any;
  setShowLoginModal?: React.Dispatch<React.SetStateAction<boolean>>;
  user?: any;
  setUser: React.Dispatch<any>;
  startTime?: string;
  endTime?: string;
}

const ChatPage = ({ tim, user, startTime, endTime, setUser }: ChatProps) => {
  return (
    <>
      {tim && (
        <AvChatRoom
          tim={tim}
          groupID={user?.imGroupId}
          userID={user?.account}
          userSig={user?.imSign}
          startTime={startTime}
          endTime={endTime}
          setUser={setUser}
        />
      )}
    </>
  );
};

export default ChatPage;
